export default __webpack_public_path__ + "static/media/textBoxFrameSmallWhite.3f47ecbe.png";